import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface ModuleDto { id: string; nombre_modulo?: string | null; url?: string | null; subtitulo?: string | null; activo: number; id_visible?: number | null; img_login?: string | null; }
export interface SubmoduleDto { id: string; nombre?: string | null; url?: string | null; activo: number; id_visible?: number | null; id_modulo: string; }
export interface CardDto { id: string; nombre_accion?: string | null; titulo?: string | null; subtitulo?: string | null; icono?: string | null; url?: string | null; seccion?: 'general' | 'config' | string | null; activo: number; img?: string | null; id_submodulo: string; orden?: number | null; }
export interface MailSettingsDto { globalEnabled: boolean; channels: Record<string, boolean>; updatedAt?: string; }

@Injectable({ providedIn: 'root' })
export class ModulesService {
  private readonly http = inject(HttpClient);

  getModules(): Observable<ModuleDto[]> {
    return this.http.get<ModuleDto[]>(`${environment.url}administracion-blister/modulos`).pipe(
      map((mods) => mods.map((m) => ({ ...m, img_login: this.toAbsolute(m.img_login) })))
    );
  }
  updateModule(id: string, body: Partial<ModuleDto>): Observable<ModuleDto> {
    return this.http
      .put<ModuleDto>(`${environment.url}administracion-blister/modulos/${id}`, body)
      .pipe(map((m) => ({ ...m, img_login: this.toAbsolute(m.img_login) })));
  }

  getSubmodules(moduleId: string): Observable<SubmoduleDto[]> {
    return this.http.get<SubmoduleDto[]>(`${environment.url}administracion-blister/modulos/${moduleId}/submodulos`);
  }
  createSubmodule(moduleId: string, nombre: string): Observable<SubmoduleDto> {
    return this.http.post<SubmoduleDto>(`${environment.url}administracion-blister/modulos/${moduleId}/submodulos`, { nombre });
  }
  updateSubmodule(id: string, body: Partial<SubmoduleDto>): Observable<SubmoduleDto> {
    return this.http.put<SubmoduleDto>(`${environment.url}administracion-blister/submodulos/${id}`, body);
  }
  deleteSubmodule(id: string): Observable<void> {
    return this.http.delete<void>(`${environment.url}administracion-blister/submodulos/${id}`);
  }

  getCards(subId: string): Observable<CardDto[]> {
    return this.http.get<CardDto[]>(`${environment.url}administracion-blister/submodulos/${subId}/cards`).pipe(map(arr => arr.map(c => ({ ...c, img: this.toAbsolute(c.img) }))));
  }
  createCard(subId: string, body: Partial<CardDto>): Observable<CardDto> {
    return this.http.post<CardDto>(`${environment.url}administracion-blister/submodulos/${subId}/cards`, body).pipe(map(c => ({ ...c, img: this.toAbsolute(c.img) })));
  }
  updateCard(cardId: string, body: Partial<CardDto>): Observable<CardDto> {
    return this.http.put<CardDto>(`${environment.url}administracion-blister/cards/${cardId}`, body).pipe(map(c => ({ ...c, img: this.toAbsolute(c.img) })));
  }
  deleteCard(cardId: string): Observable<void> {
    return this.http.delete<void>(`${environment.url}administracion-blister/cards/${cardId}`);
  }

  getMailSettings(): Observable<MailSettingsDto> {
    return this.http.get<MailSettingsDto>(`${environment.url}administracion-blister/correos/settings`);
  }

  updateMailSettings(body: Partial<MailSettingsDto>): Observable<MailSettingsDto> {
    return this.http.put<MailSettingsDto>(`${environment.url}administracion-blister/correos/settings`, body);
  }

  private toAbsolute(u?: string | null): string | null | undefined {
    if (!u) return u as any;
    if (/^https?:\/\//i.test(u)) return u;
    const base = environment.imagesUrl.endsWith('/') ? environment.imagesUrl : environment.imagesUrl + '/';

    if (u.startsWith('/api/uploads/')) return base + u.replace('/api/uploads/', '');
    if (u.startsWith('/uploads/')) return base + u.replace('/uploads/', '');
    if (u.startsWith('uploads/')) return base + u.replace('uploads/', '');
    if (u.startsWith('/modulos_login/')) return base + u.replace(/^\//, '');
    if (u.startsWith('modulos_login/')) return base + u;

    // Si sólo viene el nombre de archivo, asumimos carpeta modulos_login en el backend
    if (!u.includes('/')) return base + `modulos_login/${u}`;

    return u;
  }
}
